import type { FileButtonProps } from "./components/FileButton";
import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, type LazyComponent } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "MailFileMenu" */ "./lazyIndex"), { name: "MailFileMenu" });

export const FileButton: LazyComponent<FileButtonProps, unknown, void> = createLazyComponent(lazyModule, m => m.FileButton);
